
<div class="incrementor">
    <p-button icon="pi pi-check" class="incrementor-remove" [rounded]="true" [text]="true" (click)="remove()" [attr.data-testid]="dataTestId + '-decrement'">
        <span class="material-symbols-outlined">remove</span>
    </p-button>
    <input type="text" pInputText [value]="value" readonly />
    <p-button icon="pi pi-check" class="incrementor-add" [rounded]="true" [text]="true" (click)="add()" [attr.data-testid]="dataTestId + '-increment'">
        <span class="material-symbols-outlined">add</span>
    </p-button>
    @if (showMaxError) {
        <div class="error-text" [attr.data-testid]="dataTestId + '-error'">{{maxErrorText}}</div>
    }
</div>
